import React from 'react'
import { createPortal } from 'react-dom'

interface ConfirmDialogShellProps {
    isOpen: boolean
    children: React.ReactNode
    maxWidthClassName?: string
}

const ConfirmDialogShell: React.FC<ConfirmDialogShellProps> = ({
    isOpen,
    children,
    maxWidthClassName = 'max-w-md',
}) => {
    if (!isOpen) return null

    return createPortal(
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
            <div
                className={`bg-white dark:bg-slate-800 rounded-xl shadow-xl w-full p-6 space-y-5 max-h-[calc(100vh-2rem)] overflow-y-auto ${maxWidthClassName}`}
            >
                {children}
            </div>
        </div>,
        document.body
    )
}

export default ConfirmDialogShell
